<template>

<!-- Modal -->
<div class="modal modal-mask" id="modalEditPromo" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" style="display: block">
  <div class="modal-dialog">
    <div class="modal-content">
      <div style="background-color:#FFCC00" class="modal-header">
        <h4 class="modal-title" id="staticBackdropLabel">
            <i  class="fas fa-edit mr-2" aria-hidden="true"></i>
            MODIFICA PROMO {{promoId}}</h4>
       
      </div>
      <div class="modal-body">
        <form id="formMain" v-on:submit.prevent="submit()" >
                
                
                <div class="form-group">
                  <label for="number_doc"><strong>Descrizione</strong></label>
                  <input v-focus v-model="promo.description" type="text" class="form-control bold" placeholder="" required>
                </div>

                <div class="form-group">
                  <label for="date_doc1"><strong>Inizio promo</strong></label>
                  <input required v-model="promo.start_at" type="date" class="form-control bold" placeholder="" >
                </div>
                <div class="form-group">
                  <label for="date_doc2"><strong>Fine promo</strong></label>
                  <input required v-model="promo.end_at" type="date" class="form-control bold" placeholder="" >
                </div>
                     
                                       

    <div class="form-group form-check ml-4">
      <input type="checkbox" class="form-check-input pointer" id="exampleCheck1" v-model="promo.active">
      <label class="form-check-label" for="exampleCheck1">Attiva promo</label>
    </div>

    <div v-if="company.Id==1" class="form-group form-check ml-4">
      <input type="checkbox" class="form-check-input pointer" id="exampleCheck2" v-model="flag">
      <label class="form-check-label" for="exampleCheck2">SAPIA CLUB</label>
    </div>
    


                
                
               

                <button @click="$emit('hide')" type="button" class="btn btn-secondary mt-2 mb-2" data-dismiss="modal">                    
                    ANNULLA
                </button>
        
            <button type="submit"  class="btn btn-primary float-right mt-2 mb-2">
              <i class="fas fa-edit mr-2" aria-hidden="true"></i>
              MODIFICA
            <span v-if="spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>       
      </form>


      </div>
      <div class="modal-footer">
         <alert-box class="mt-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
        
           <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Chiudi</button>-->
        
      </div>
    </div>
  </div>
</div>


</template>
<script>


import api              from '@/api';
import alertBox         from '@/components/common/AlertBox.vue';
import { mapGetters }   from 'vuex';
export default {
  
  components: {alertBox
  
  },  
  props: ['promoId'],
 
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },  
 data () {
    return {
      
      promo           : {},
      alert           : false,
      spinner         : false,
     
      msg             : {
          
         title : '',
         body  : '',
         type  : 0
      },
      
      flag : false

    }
  },

computed: 
  {
   
      ...mapGetters(['company'])
  },
mounted()
{   
    
   
},
created()
{ 
  if(this.promoId>0)
  {

    this.getData()
  }  
},

methods: 
{
    async getData()
    {
       
        this.msg.title = ''
        var data = {'promoId' : this.promoId}
        var sp   = {'sp'         : 'spPromo'}
        var json = Object.assign(data, sp);
       
        this.spinner = true
        await api.post(json).then(res => {
                   
          if(res.status == 200)
            {
              this.promo = res.data.recordsets[0][0]
              const flag = res.data.recordsets[0][0].sapia_club_promoId 
              this.flag = false
              if(flag)
              {
                this.flag = true
              }
              
            }
           else if(res.status == 500)
           {
                                          
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1
                    
           } 
           else
            {
                             
              this.msg.title =  'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1               
                 
            } 
          
          }).catch(err => {
                           
              this.msg.title =  'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1                 
              
          }).finally(() => {
              this.spinner = false
        });


	},
  
   
        
  async submit() 
  {
    
    this.spinner = true
    const data  = {'promoId':this.promoId,'description':this.promo.description,'start_at':this.promo.start_at,'end_at':this.promo.end_at,'active':Number(this.promo.active),'flag':this.flag}       
    const sp    = {'sp':'spUpdatePromo'}
    const json  = Object.assign(data, sp);

    await api.post(json).then(res => {
          
          if(res.status == 200)
            {
              this.$emit('hide')  
            }
           else if(res.status==500)
           {
                          
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1                
                    
           } 
           else
            {
                           
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1 
            } 
          
          }).catch(err => {
                           
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1 
              
          }).finally(() => {
          this.spinner = false
        });



	}
  
      
}
    
}    
</script>

<style scoped>

 
.bold {
  font-weight: bolder;
}

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;
}
.pointer:hover
{
  background-color : blue;
  color            : white;
  cursor           : pointer;
}
.form-check-label
{
  cursor : pointer;
}
</style>